export default "__VITE_ASSET__CSkn9gc9__"